import { render, staticRenderFns } from "./ChatFeedPanel.vue?vue&type=template&id=07943d3d&scoped=true"
import script from "./ChatFeedPanel.vue?vue&type=script&lang=js"
export * from "./ChatFeedPanel.vue?vue&type=script&lang=js"
import style0 from "./ChatFeedPanel.vue?vue&type=style&index=0&id=07943d3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07943d3d",
  null
  
)

export default component.exports